import { FormControl } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormInfo extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(nextId: number, pageId: string): void {
    super.initEmpty(nextId, pageId);
    this.form.get('type').setValue(QuestionType.InfoPage);
    this.form.get('title').setValue('Information Page');
    this.form.get('information').setValue('');
    this.form.get('requiredInd').setValue(false);
  }

  init(question: Question): void {
    super.init(question);
  }

  private extendFormGroup(): void {
    this.form.addControl('information', new FormControl<string>(''));
  }
}
